module.exports = __webpack_public_path__ + "static/media/IMG_20201128_155426_398_tn.cbab44c0.jpg";